import { useRef as l } from "react";
import { getDrawerStyle as T } from "./index.es902.js";
import { useDrawerAnimation as W } from "./index.es5752.js";
import { useDrawerPortalContainer as j } from "./index.es5753.js";
import { useDrawerDragging as k } from "./index.es5754.js";
const I = ({
  isOpen: f,
  setIsOpen: n,
  position: r = "right",
  width: s = "400px",
  height: g = "100%",
  container: u,
  snapPoints: t = [],
  activeSnapPoint: o,
  setActiveSnapPoint: m,
  closeThreshold: h = 0.5,
  onDrag: c,
  onRelease: D,
  snapToSequentialPoint: d = !1
}) => {
  const e = l(null), w = l(!1), { portalContainer: C, isCustomContainer: i } = j(u), S = T(r, s, g, i), { rendered: y, applySnapPoint: H, setIsDragging: R, getCurrentOffset: p } = W(
    f,
    r,
    e,
    t,
    o
  ), x = () => e.current ? r === "left" || r === "right" ? e.current.offsetWidth : e.current.offsetHeight : 0, { handleDragStart: b, handleDragMove: A, handleDragEnd: B } = k(
    e,
    r,
    t,
    o,
    m,
    n,
    h,
    c,
    D,
    d,
    p,
    (a) => {
      w.current = a, R(a);
    },
    x,
    H
  ), E = r === "bottom" && t.length > 0, M = r === "top" && t.length > 0;
  return {
    drawerRef: e,
    rendered: y,
    styles: S,
    portalContainer: C,
    handleClose: () => n(!1),
    handleDragStart: b,
    handleDragMove: A,
    handleDragEnd: B,
    shouldShowTopHandle: E,
    shouldShowBottomHandle: M
  };
};
export {
  I as useDrawer
};
//# sourceMappingURL=index.es904.js.map
